import { FC } from 'react';
import { IOrganizationalTeam } from '../types';



export const OrganizationalTeam: FC<IOrganizationalTeam> = ({ contactsData }) => {
  return (
    <div className="flex flex-col mx-6 mb-6 gap-4">
      <h3 className="text-2xl lg:text-3xl font-bold mb-6">{contactsData.organizationalTeam.name}</h3>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8 lg:gap-12 mx-6 mb-6 break-words">
        {contactsData.organizationalTeam.sections.map((section, index) => 
          <div key={index} className="flex flex-col items-center justify-between bg-primary-default hover:bg-primary-dark hover:text-white rounded-md p-2 sm:p-4 text-center">
            <p className="font-semibold mb-4">{section.type}</p>
            <p className="font-bold text-xl mb-4">{section.contactPerson.title} {section.contactPerson.firstName} {section.contactPerson.lastName}</p>
            <p className="underline mb-4">{section.contactPerson.email}</p>
            <p className="font-semibold">{section.contactPerson.phoneNumber}</p>
          </div>
        )}
      </div> 
    </div> 
  )
}